import { NotificationType } from '../../../../../services/exports/Constants';

export default {
  title: 'Du har {{length}} notifikationer',
  notifications: {
    titles: {
      [NotificationType.PaymentGatewayVerificationPending]: 'Betalingsoplysninger under gennemgang',
      [NotificationType.PaymentGatewayVerificationSuccessful]: 'Betalingsoplysninger godkendt',
      [NotificationType.PaymentGatewayVerificationFailed]: 'Fejl i betalingsoplysninger',
    },
    descriptions: {
      [NotificationType.PaymentGatewayVerificationPending]:
        'Dine betalingsoplysninger gennemgås af Stripe. Det kan tage op til 48 timer.',
      [NotificationType.PaymentGatewayVerificationSuccessful]:
        'Dine betalingsoplysninger er verificeret. Du kan nu modtage betalinger.',
      [NotificationType.PaymentGatewayVerificationFailed]:
        'Der ser ud til at være en fejl i dine oplysninger. Klik her for at opdatere dine oplysninger.',
    },
  },
};
